// extracted by mini-css-extract-plugin
export default {"image":"G1-z","loaded":"H1-z"};